import { create } from 'zustand';
import { LocationInfo } from '@/api/merchant.api';
import { storeRegistry } from './storeRegistry';

// State interface
interface ActiveLocationsState {
  activeLocationIds: string[];
  isAllSelected: boolean;
  availableLocations: LocationInfo[];
  
  // Actions
  setActiveLocations: (locationIds: string[], availableLocations: LocationInfo[]) => void;
  setAvailableLocations: (locations: LocationInfo[]) => void;
  reset: () => void;
}

// Initial state
const initialState = {
  activeLocationIds: [],
  isAllSelected: true,
  availableLocations: [],
};

// Create the store
export const useActiveLocationsStore = create<ActiveLocationsState>((set, get) => ({
  ...initialState,
  
  setActiveLocations: (locationIds, availableLocations) => {
    const current = get();
    
    // Backend sends empty array to mean "all selected", convert it to all IDs
    const normalizedLocationIds = locationIds.length === 0 
      ? availableLocations.map(loc => loc.locationId)
      : locationIds;
    
    // Only update if values actually changed (compare sorted strings for order-independence)
    const currentIdsKey = [...current.activeLocationIds].sort().join(',');
    const newIdsKey = [...normalizedLocationIds].sort().join(',');
    const locationIdsChanged = currentIdsKey !== newIdsKey;
    
    const currentLocsKey = current.availableLocations.map(l => l.locationId).sort().join(',');
    const newLocsKey = availableLocations.map(l => l.locationId).sort().join(',');
    const availableLocationsChanged = currentLocsKey !== newLocsKey;
    
    if (locationIdsChanged || availableLocationsChanged) {
      const isAllSelected = normalizedLocationIds.length === availableLocations.length;
      
      set({
        activeLocationIds: normalizedLocationIds,
        isAllSelected,
        availableLocations,
      });
    }
  },
  
  setAvailableLocations: (locations) => {
    set({ availableLocations: locations });
  },
  
  reset: () => {
    set(initialState);
  }
}));

// Register the store with the registry for global reset
storeRegistry.register(useActiveLocationsStore);

